
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';

export function getUpdateDocumenttypeDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    prettyName: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    containertypeId: new FormControl<number | undefined>(undefined),
    sortableRank: new FormControl<number | undefined>(undefined),
    itemdocument: new FormControl<boolean | undefined>(undefined),
    active: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    relatedStandardtaskId: new FormControl<number | undefined>(undefined),
    identifierName: new FormControl<string | undefined>(undefined),
})
;
}
      